<!-- Заголовок дерева -->
<ng-container *ngIf="service.config.titleTree">
    <div class="tree-title-block tree-title-block-margin-bottom">
        {{ service.config.titleTree }}
        <button
            type="button"
            class="tree-title-block-right button-icon button-icon-background"
            mat-button
            [class.active]="expandAll"
            (click)="expandAllToggle()"
            [title]="
                expandAll
                    ? appService.language_dictionary.report_collapse_all
                    : appService.language_dictionary.report_expand_all
            "
        >
            <mat-icon fontSet="mdi" fontIcon="mdi-format-line-spacing"></mat-icon>
        </button>
    </div>
</ng-container>

<!-- Поиск по дереву -->
<ng-container *ngIf="service.config.listNodes?.length > 5">
    <div class="tree-panel relative">
        <app-input-search
            [label]="appService.language_dictionary.input_search_placeholder"
            [showToggleArrowButtons]="searchType[service.config.filterType]?.showToggleArrowButtons"
            [positionIcon]="searchType[service.config?.filterType].positionIcon"
            [icon]="searchType[service.config.filterType].icon"
            [disableDown]="service.filterResultIndex === service?.filterResult?.length - 1"
            [disableUp]="service.filterResultIndex < 1"
            (switching)="showFilteredNode($event)"
            (inputEvent)="changeFilterRow($event)"
            (searchEvent)="filterService($event)"
        >
        </app-input-search>
        <ng-container
            *ngIf="(!service.config.listNodes?.length || !service.dataSource.data?.length) && service.config?.buttonAdd"
        >
            <fui-button
                (clickEvent)="openTreeForCreateNode()"
                [label]="appService.language_dictionary.system_add_in_registry"
                [disabled]="isCreatingNewNode$ | async"
                color="soft"
                height="slim"
                icon="plus"
                class="absolute top-3 right-12"
            >
            </fui-button>
        </ng-container>
    </div>
</ng-container>

<div class="tree-select-container">
    <div fxLayout="column" class="tree-block">
        <!-- Дерево с полем для создания нового узла -->
        <mat-tree id="addTree" cdkDropList [treeControl]="defaultTreeControl" [dataSource]="inputNode$ | async">
            <mat-tree-node *matTreeNodeDef="let node" cdkDrag cdkDragLockAxis="y" [cdkDragData]="node">
                <div *cdkDragPreview></div>
                <ng-container [ngTemplateOutlet]="createNewNode" [ngTemplateOutletContext]="{ node }"> </ng-container>
            </mat-tree-node>
        </mat-tree>
        <div class="tree-scroll-div-wrapper">
            <!-- Контейнер дерева -->
            <div
                #treeContainer
                cdkDropListGroup
                cdkScrollable
                *ngIf="service.config.listNodes?.length > 0"
                class="tree-scroll-div"
                [id]="'treeContainer-' + this.service.config.id"
            >
                <!-- Дерево с единичным выбором -->
                <ng-container *ngIf="!service.config.isMultiple; else multipleTree">
                    <mat-tree
                        [id]="this.service.config.id"
                        [dataSource]="service.dataSource"
                        cdkDropList
                        [treeControl]="treeControl"
                        (cdkDropListDropped)="dropInputNode($event)"
                        class="tree-select-tree"
                    >
                        <!-- Узел -->
                        <mat-tree-node
                            cdkDrag
                            [cdkDragDisabled]="true"
                            [cdkDragData]="node"
                            #treeNode="matTreeNode"
                            #treeNodeRef
                            data-id="{{ node.id }}"
                            *matTreeNodeDef="let node"
                            matTreeNodeToggle
                            [matTreeNodePadding]="node?.level"
                            (click)="clickNode(node)"
                            (dblclick)="clickNode(node)"
                            class="mat-tree-node mat-tree-node-hover"
                            [class.mat-tree-node-focused]="service.focusedNode?.id == node.id"
                            [class.mat-tree-node-selected]="service.selectNode == node"
                            tabIndex="0"
                        >
                            <div class="mat-tree-node-item-wrapper">
                                <!-- Особая иконка для узла -->
                                <ng-container *ngIf="node?.icon">
                                    <mat-icon class="mat-icon-tree mat-icon-rtl-mirror folder-icon">
                                        <i [class]="'mdi mdi-' + getNodeIcon(node)"></i>
                                    </mat-icon>
                                </ng-container>
                                <mat-label
                                    class="mat-tree-node-item"
                                    [matTooltip]="node.name"
                                    [highlight]="treeSearch"
                                    [text]="node.name"
                                >
                                </mat-label>
                            </div>
                        </mat-tree-node>

                        <!-- Узел, которые имеет вложенные узлы -->
                        <mat-tree-node
                            cdkDrag
                            [cdkDragDisabled]="true"
                            [cdkDragData]="node"
                            data-id="{{ node.id }}"
                            #treeNode="matTreeNode"
                            #treeNodeRef
                            *matTreeNodeDef="let node; when: hasChild"
                            [class.mat-tree-node-focused]="service.focusedNode?.id == node.id"
                            [class.mat-tree-node-selected]="service.selectNode == node"
                            [class.mat-tree-node-hover]="service.config.isFolderSelect"
                            (click)="clickNode(node)"
                            (dblclick)="clickNode(node)"
                            [ngClass]="'level_' + node?.level"
                            [matTreeNodePadding]="node?.level"
                            tabIndex="0"
                        >
                            <div class="mat-tree-node mat-tree-node-parent">
                                <div class="mat-tree-node-item-wrapper">
                                    <div class="icon-div" [ngClass]="{ 'icon-div': node?.icon }">
                                        <div class="expand-button">
                                            <fui-button
                                                *ngIf="node.hasOwnProperty('children')"
                                                (clickEvent)="$event.stopPropagation(); toggleNode(node)"
                                                tabindex="-1"
                                                [disabled]="node.children?.length == 0"
                                                [type]="'button-icon'"
                                                [icon]="treeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right'"
                                                [height]="'slim'"
                                                [color]="'flat'"
                                                [borderRadius]="'circle'"
                                                [iconSize]="20"
                                            >
                                            </fui-button>
                                        </div>
                                        <!-- Особая иконка для узла -->
                                        <ng-container *ngIf="node.level > 0 && node?.icon">
                                            <mat-icon class="mat-icon-tree mat-icon-rtl-mirror folder-icon">
                                                <i [class]="'mdi mdi-' + getNodeIcon(node)"></i>
                                            </mat-icon>
                                        </ng-container>
                                    </div>
                                    <mat-label
                                        class="mat-tree-node-item"
                                        [matTooltip]="node.name"
                                        [highlight]="treeSearch"
                                        [text]="node.name"
                                    >
                                    </mat-label>
                                </div>
                            </div>
                        </mat-tree-node>

                        <mat-tree-node
                            *matTreeNodeDef="let node; when: isCreateNewNode"
                            cdkDrag
                            cdkDragLockAxis="y"
                            [matTreeNodePadding]="node?.level"
                            [cdkDragData]="node"
                        >
                            <div *cdkDragPreview></div>
                            <ng-container [ngTemplateOutlet]="createNewNode" [ngTemplateOutletContext]="{ node }">
                            </ng-container>
                        </mat-tree-node>
                    </mat-tree>
                </ng-container>

                <!-- Дерево с множественным выбором -->
                <ng-template #multipleTree>
                    <mat-tree
                        [id]="this.service.config.id"
                        cdkDropList
                        [dataSource]="service.dataSource"
                        [treeControl]="treeControl"
                        (cdkDropListDropped)="dropInputNode($event)"
                        class="tree-select-tree"
                    >
                        <mat-tree-node
                            *matTreeNodeDef="let node"
                            #treeNodeRef
                            #treeNode="matTreeNode"
                            cdkDrag
                            [cdkDragDisabled]="true"
                            [cdkDragData]="node"
                            data-id="{{ node.id }}"
                            [class.tree-node-conditionally-del]="service.convertTypeRubricatorFlagDel(node)"
                            matTreeNodeToggle
                            [matTreeNodePadding]="node?.level"
                            (click)="clickNode(node)"
                            class="mat-tree-node mat-tree-node-hover"
                            [class.mat-tree-node-focused]="service.focusedNode?.id == node.id"
                            [class.mat-tree-node-selected]="service.selectNode?.id == node.id"
                        >
                            <div class="mat-tree-node-item-wrapper">
                                <mat-checkbox
                                    class="checklist-leaf-node"
                                    [disableRipple]="true"
                                    [disabled]="node.disabled"
                                    (click)="$event.preventDefault()"
                                    [checked]="service.checklistSelection.isSelected(node?.id | formater: 'string')"
                                >
                                    <!-- Особая иконка для узла -->
                                    <ng-container *ngIf="node?.icon">
                                        <mat-icon class="mat-icon-tree mat-icon-rtl-mirror folder-icon">
                                            <i [class]="'mdi mdi-' + getNodeIcon(node)"></i>
                                        </mat-icon>
                                    </ng-container>
                                    <mat-label
                                        class="mat-tree-node-item"
                                        [highlight]="treeSearch"
                                        [matTooltip]="node.name"
                                        [text]="node.name"
                                    >
                                    </mat-label>
                                </mat-checkbox>
                                <ng-container
                                    *ngIf="
                                        service.config.hasOwnProperty('hasOwnProperty') &&
                                        service.config?.treeIconsObject.hasOwnProperty(node.id)
                                    "
                                >
                                    <mat-icon fontSet="mdi" fontIcon="mdi-check-circle-outline"></mat-icon>
                                </ng-container>
                            </div>
                        </mat-tree-node>

                        <mat-tree-node
                            *matTreeNodeDef="let node; when: hasChild"
                            #treeNode="matTreeNode"
                            #treeNodeRef
                            cdkDrag
                            [cdkDragDisabled]="true"
                            [cdkDragData]="node"
                            data-id="{{ node.id }}"
                            [matTreeNodePadding]="node?.level"
                            (click)="clickNode(node)"
                            [ngClass]="'level_' + node?.level"
                            [class.mat-tree-node-focused]="service.focusedNode?.id == node.id"
                            [class.mat-tree-node-selected]="service.selectNode?.id == node.id"
                            [class.mat-tree-node-hover]="service.config.isFolderSelect"
                        >
                            <div class="mat-tree-node mat-tree-node-parent">
                                <div class="mat-tree-node-item-wrapper">
                                    <mat-checkbox
                                        [disabled]="node.disabled"
                                        (click)="$event.preventDefault()"
                                        [disableRipple]="true"
                                        [checked]="descendantsAllSelected(node)"
                                        [indeterminate]="descendantsPartiallySelected(node)"
                                    >
                                        <div class="icon-div" [ngClass]="{ 'icon-div': node?.icon }">
                                            <div class="expand-button">
                                                <fui-button
                                                    *ngIf="node.hasOwnProperty('children')"
                                                    (clickEvent)="$event.stopPropagation(); toggleNode(node)"
                                                    tabindex="-1"
                                                    [disabled]="node.children?.length == 0"
                                                    [type]="'button-icon'"
                                                    [icon]="
                                                        treeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right'
                                                    "
                                                    [height]="'slim'"
                                                    [color]="'flat'"
                                                    [borderRadius]="'circle'"
                                                    [iconSize]="20"
                                                >
                                                </fui-button>
                                            </div>
                                            <!-- Особая иконка для узла -->
                                            <ng-container *ngIf="node.level > 0 && node?.icon">
                                                <mat-icon class="mat-icon-tree mat-icon-rtl-mirror folder-icon">
                                                    <i [class]="'mdi mdi-' + getNodeIcon(node)"></i>
                                                </mat-icon>
                                            </ng-container>
                                        </div>
                                        <mat-label
                                            class="mat-tree-node-item"
                                            [matTooltip]="node.name"
                                            [highlight]="treeSearch"
                                            [text]="node.name"
                                        >
                                        </mat-label>
                                    </mat-checkbox>
                                </div>
                            </div>
                        </mat-tree-node>

                        <mat-tree-node
                            *matTreeNodeDef="let node; when: isCreateNewNode"
                            cdkDrag
                            cdkDragLockAxis="y"
                            [matTreeNodePadding]="node?.level"
                            [cdkDragData]="node"
                        >
                            <div *cdkDragPreview></div>
                            <ng-container [ngTemplateOutlet]="createNewNode" [ngTemplateOutletContext]="{ node }">
                            </ng-container>
                        </mat-tree-node>
                    </mat-tree>
                </ng-template>
            </div>
        </div>
        <!-- Отсутствие совпадений -->
        <ng-container *ngIf="!service.config.listNodes?.length || !service.dataSource.data?.length">
            <div class="empty-tree h-full flex flex-col">
                <div class="h-full flex flex-col items-center justify-center text-[#bdbdbd]">
                    <mat-icon
                        aria-hidden="true"
                        class="icon-80 !flex items-center"
                        fontSet="mdi"
                        fontIcon="mdi-text-box-search"
                    >
                    </mat-icon>
                    <div class="empty-tree-message">
                        {{ appService.language_dictionary.rubricator_search_empty }}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #createNewNode let-node="node">
    <div class="flex flex-row items-center input-new-node">
        <!-- Иконка -->
        <div class="input-new-node-icon-left mx-[4px] cursor-pointer">
            <mat-icon
                cdkDragHandle
                aria-hidden="true"
                fontSet="mdi"
                fontIcon="mdi-drag-vertical"
                [fuiTooltip]="appService.language_dictionary.drag_and_drop_hint"
            >
            </mat-icon>
        </div>
        <!-- Поле ввода -->
        <mat-form-field appearance="outline" class="flex flex-row items-center relative">
            <input matInput type="text" class="input-new-node-value" [(ngModel)]="node.name" />
            <!-- Кнопка "Очистить" -->
            <ng-container *ngIf="node.name?.length > 0">
                <fui-button
                    (clickEvent)="node.name = ''"
                    [title]="appService.language_dictionary.system_clear"
                    class="absolute right-0"
                    type="button-icon"
                    height="slim"
                    color="flat"
                    borderRadius="circle"
                    icon="close"
                    iconSize="14"
                >
                </fui-button>
            </ng-container>
        </mat-form-field>
        <!-- Кнопка "Отменить" -->
        <fui-button
            (clickEvent)="cancelAddNewNode()"
            [title]="appService.language_dictionary.system_cancel"
            [iconSize]="16"
            class="mx-[4px]"
            type="button-icon"
            color="flat"
            height="slim"
            textColor="#2B3B4C"
            borderRadius="circle"
            icon="pencil-off-outline"
        >
        </fui-button>
        <!-- Кнопка "Сохранить" -->
        <fui-button
            (clickEvent)="saveNewNode(node)"
            [title]="appService.language_dictionary.system_add"
            class="mr-[4px]"
            type="button-icon"
            color="flat"
            height="slim"
            textColor="#2B3B4C"
            borderRadius="circle"
            iconSize="16"
            icon="checkbox-marked-circle-outline"
        >
        </fui-button>
    </div>
</ng-template>
